export const buyerTodayReducer = (
  state = { loading: false, buyerToday: [] },
  { type, payload }
) => {
  switch (type) {
    case "BUYER_TODAY_LOADING":
      return { ...state, loading: true };
    case "BUYER_TODAY":
      return { ...state, buyerToday: payload, loading: false };
    case "BUYER_TODAY_LOADDED":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const buyerUpcomingReducer = (
  state = { buyerUpcoming: [], loading: false,asideBuyerUpcoming:[],loadings:false },
  { type, payload }
) => {
  switch (type) {
    case "BUYER_UPCOMING_LOADING":
      return { ...state, loading: true };
    case "BUYER_UPCOMING":
      return { ...state, buyerUpcoming: payload, loading: false };
    case "BUYER_UPCOMING_LOADDED":
      return { ...state, loading: false };
      case "BUYER_UPCOMING_LOADING_ASIDE":
      return { ...state, loadings: true };
    case "BUYER_UPCOMING_ASIDE":
      return { ...state, asideBuyerUpcoming: payload, loadings: false };
    case "BUYER_UPCOMING_LOADDED_ASIDE":
      return { ...state, loadings: false };
    default:
      return state;
  }
};

export const buyerPiadEmdReducer = (
  state = { paidEmdData: [], loadings: false },
  { type, payload }
) => {
  switch (type) {
    case "BUYER_PAID_LOADING":
      return { ...state, loadings: true };
    case "BUYER_PAID_EMD":
      return { ...state, paidEmdData: payload, loadings: false };
    case "BUYER_PAID_LOADDED":
      return { ...state, loadings: false };
    default:
      return state;
  }
};

export const getTodayOffersReducer = (
  state = {
    loading: false,
    todayUpComingOffers: []
  },
  payload
) => {
  switch (payload.type) {
    case "GETING_TODAY_OFFERS":
      return { ...state, loading: true };

    case "GOT_TODAY_OFFERS":
      return { ...state, todayUpComingOffers: payload.payload, loading: false };
    case "CANNOT_GET_TODAY_OFFERS_LOADED":
      return { ...state, loading: false };
    default:
      return state;
  }
};



export const getAllInvitesReducer = (
  state = {
    loading: false,
    allInvites: []
  },
  payload
) => {
  switch (payload.type) {
    case "GETTING_ALL_INVITES":
      return { ...state, loading: true };

    case "GOT_ALL_IVITES":
      return { ...state, allInvites: payload.payload, loading: false };
    case "CANNOT_GET_INVITES":
      return { ...state, loading: false };
    default:
      return state;
  }
};
